import React from "react";

function Hero() {
  return (
    <div>
      <div id="hero" className="min-h-svh py-40">
        <div className="w-screen h-full flex items-center flex-col justify-center px-5 z-40 overflow-x-0">
          <h1 className="font-header leading-[.85] text-4xl md:text-[5rem] text-center uppercase font-thin text-white text-shadow pt-10 z-50">
            Kara Thurmond
          </h1>
          <h2 className="font-header text-xl md:text-2xl text-center uppercase font-thin text-white text-shadow tracking-widest lg:tracking-[.8rem]">
            Web Designer/Developer
          </h2>

          <h2 className="font-header text-xl md:text-2xl text-center font-medium text-white text-shadow py-8 tracking-wide">
            New Site In the Works!
          </h2>
          <p className="font-header text-lg md:text-xl text-center font-thin text-white text-shadow py-2 tracking-wide">
            In the meantime, feel free to reach out for project inquiries.
          </p>
          <div className="flex flex-col md:flex-row md:space-x-10 font-thin tracking-wide text-center">
            <a href="https://www.linkedin.com/in/karathurmond/">
              Linkedin: @karathurmond
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
